import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";

import { FIRM } from "@/lib/firm";

export function headingId(heading: string) {
  return heading
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Desktop-only rail: jump list for the guide's sections plus a persistent
 * fixed-fee quote card. Hidden below xl so the reading column stays centred.
 */
export function GuideSidebar({
  headings,
  hasFaq,
}: {
  headings: ReadonlyArray<string>;
  hasFaq: boolean;
}) {
  return (
    <aside className="sticky top-28 hidden self-start xl:block">
      <nav aria-label="On this page">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent-foreground/70">
          On this page
        </p>
        <ul className="mt-4 space-y-2.5 border-l border-border pl-4">
          {headings.map((h) => (
            <li key={h}>
              <a
                href={`#${headingId(h)}`}
                className="block text-sm leading-snug text-muted-foreground transition-colors hover:text-primary"
              >
                {h}
              </a>
            </li>
          ))}
          {hasFaq && (
            <li>
              <a
                href="#faq"
                className="block text-sm leading-snug text-muted-foreground transition-colors hover:text-primary"
              >
                Common questions
              </a>
            </li>
          )}
        </ul>
      </nav>

      <div className="mt-8 rounded-sm border border-border bg-card p-5">
        <p className="font-serif text-lg leading-snug text-foreground">
          Need a fixed fee for your own matter?
        </p>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          Solicitor-led, priced up front, no hourly surprises.
        </p>
        <Link
          to="/contact"
          className="mt-4 flex items-center justify-center rounded-sm bg-accent px-4 py-2.5 text-sm font-semibold text-accent-foreground transition-opacity hover:opacity-90"
        >
          Get a quote
        </Link>
        <a
          href={FIRM.phoneHref}
          className="mt-2 flex items-center justify-center gap-2 rounded-sm border border-border px-4 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-secondary"
        >
          <Phone className="size-4" aria-hidden="true" />
          {FIRM.phone}
        </a>
      </div>
    </aside>
  );
}
